import type { GroupPreviewType, GroupType } from 'models';

const supportedGroupScope = {
  associations: 1,
  denominations: 1,
  districts: 1,
  jurisdictions: 1,
  organizations: 1,
  privateLabelApps: 1,
  regions: 1,
  'state-conventions': 1,
};

export type GroupScope = keyof typeof supportedGroupScope;

export const isGroupScope = (scope: unknown): scope is GroupScope =>
  typeof scope === 'string' ? scope in supportedGroupScope : false;

export const getGroupTypeFromScope = ({
  entityScope,
}: {
  entityScope: Exclude<GroupScope, 'organizations'>;
}): GroupType => {
  switch (entityScope) {
    case 'associations':
      return 'association';
    case 'denominations':
      return 'denomination';
    case 'districts':
      return 'district';
    case 'jurisdictions':
      return 'jurisdiction';
    case 'privateLabelApps':
      return 'private_label_app';
    case 'regions':
      return 'region';
    case 'state-conventions':
      return 'state_convention';
  }
};

export const getGroupScopeFromPreviewType = ({ groupType }: { groupType: GroupPreviewType }): GroupScope => {
  switch (groupType) {
    case 'association':
      return 'associations';
    case 'denomination':
      return 'denominations';
    case 'district':
      return 'districts';
    case 'jurisdiction':
      return 'jurisdictions';
    case 'organization':
      return 'organizations';
    case 'private_label_app':
      return 'privateLabelApps';
    case 'region':
      return 'regions';
    case 'state_convention':
      return 'state-conventions';
  }
};
